__turbopack_context__.v({
  "button": "c8Of3W_button",
  "container": "c8Of3W_container",
  "isDefault": "c8Of3W_isDefault",
  "isLocked": "c8Of3W_isLocked",
});
